let audio = new Audio("");
const correctSound = new Audio("./audios/correct.mp3");
const wrongSound = new Audio("./audios/incorrect.mp3");
const beep = new Audio("./audios/button_click.mp3");
const mainMusic = new Audio("./audios/The_Biggest_Smile.mp3")
const freeMusic = new Audio("./audios/Passing_Time.mp3")
const timeMusic = new Audio("./audios/Happy_Dreams.mp3")


export function audioPreLoad(){
    beep.pause();

}

export function playButtonTap(){
    if(localStorage.getItem('soundon') === "1" || localStorage.getItem('soundon') == null){
        //beep.pause();
        //beep.src = "./audios/button_click.mp3";
        //beep = new Audio("./audios/button_click.mp3");
        beep.volume = 0.8;
        beep.play();
    }
}

export function playCorrect(){
    if(localStorage.getItem('soundon') === "1" || localStorage.getItem('soundon') == null){
        correctSound.volume = 0.8;
        correctSound.play();
    }
}
export function playWrong(){
    if(localStorage.getItem('soundon') === "1" || localStorage.getItem('soundon') == null){
        wrongSound.volume = 0.8;
        wrongSound.play();
    }
}

export function playMainMusic(){
    timeMusic.pause();
    timeMusic.currentTime = 0;
    freeMusic.pause();
    freeMusic.currentTime = 0;
    mainMusic.volume = 0.6;
    if(localStorage.getItem('musicon') === "1" || localStorage.getItem('musicon') == null){
        mainMusic.addEventListener('ended', function () {
            mainMusic.play();
            }, false);
        mainMusic.play();
        }
}

export function stopMainMusic(){
    mainMusic.pause();
}

export function playFreeMusic(){
    mainMusic.pause();
    mainMusic.currentTime = 0;
    timeMusic.pause();
    timeMusic.currentTime = 0;
    freeMusic.volume = 0.6;
    if(localStorage.getItem('musicon') === "1" || localStorage.getItem('musicon') == null){
        freeMusic.addEventListener('ended', function () {
            freeMusic.play();
            }, false);
        freeMusic.play();
        }
}

export function playTimeMusic(){
    mainMusic.pause();
    mainMusic.currentTime = 0;
    freeMusic.pause();
    freeMusic.currentTime = 0;
    timeMusic.volume = 0.6;
    if(localStorage.getItem('musicon') === "1" || localStorage.getItem('musicon') == null){
        timeMusic.addEventListener('ended', function () {
            timeMusic.play();
            }, false);
        timeMusic.play();
        }
}


// WEBPACK FOOTER //
// ./src/components/PlaySounds.js